// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import common from '../common/common'
import constants from '../common/constants'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as filter from '../common/filter'

Vue.prototype.common = common;
Vue.prototype.constants = constants;
Vue.config.productionTip = false;
Vue.use(ElementUI);

Object.keys(filter).forEach(item => {
  Vue.filter(item, filter[item]);
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js